import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TransactionsComponent } from './transactions.component';
import { FasServiceTableComponent } from 'fas-services';

@NgModule({
  declarations: [TransactionsComponent],
  imports: [
    FasServiceTableComponent,
    CommonModule
  ],
})
export class TransactionsModule {}
